'use client';

import { useMDXComponent } from 'next-contentlayer2/hooks';
import DiscordIcon from 'components/UI/SvgIcons/DiscordIcon';
import InternalLink from 'components/UI/InternalLink/InternalLink';
import ExternalLink from 'components/UI/InternalLink/InternalLink';

type Props = { code: string };

const components = {
  InternalLink,
  DiscordIcon,
  a: ExternalLink,
};

const MdxContent = ({ code }: Props) => {
  const MDXContent = useMDXComponent(code);

  return <MDXContent components={components} />;
};

export default MdxContent;
